import React, { createContext, useState } from 'react';

export const ApplicationsContext = createContext();

export const ApplicationsProvider = ({ children }) => {
  const [page, setPage] = useState(1);
  const [filterBody, setFilterBody] = useState();
  const [phoneFilter, setPhoneFilter] = useState([]);
  const [dateTimeLtFilter, setDateTimeLtFilter] = useState();
  const [dateTimeGtFilter, setDateTimeGtFilter] = useState();
  const [sortOrder, setSortOrder] = useState('asc');

  const clearFilters = callback => {
    setPhoneFilter([]);

    setDateTimeGtFilter();
    setDateTimeLtFilter();

    setFilterBody();

    if (callback) callback();
  };

  return (
    <ApplicationsContext.Provider
      value={{
        page,
        setPage,
        filterBody,
        setFilterBody,
        phoneFilter,
        setPhoneFilter,
        dateTimeLtFilter,
        setDateTimeLtFilter,
        dateTimeGtFilter,
        setDateTimeGtFilter,
        sortOrder,
        setSortOrder,
        clearFilters,
      }}
    >
      {children}
    </ApplicationsContext.Provider>
  );
};
